import React, { useState } from 'react';
import { Form, Button } from 'react-bootstrap';

const SpecialInstructionInput = ({
  splInsOptions = [],
  formData,
  setFormData,
  handlePrescriptionModal,
  errors,
  disabled
}) => {
  const [showOptions, setShowOptions] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      splins: e.target.value,
      special_instruction_text: e.target.value
    }));
  };

  const handleSelect = (value) => {
    setFormData((prev) => ({
      ...prev,
      splins: value
    }));
    setShowOptions(false);
  };

  // const displayValue = (() => {
  //   const matched = splInsOptions.find(
  //     (opt) => String(opt.value) === String(formData.splins)
  //   );
  //   return matched ? matched.key : formData.splins;
  // })();

  const displayValue = (() => {
    if (formData.splins === "" || formData.splins == null) return "";
    const matched = splInsOptions.find(
      (opt) => String(opt.value) === String(formData.splins)
    );
    return matched ? matched.key : formData.splins || formData.special_instruction_text || "";
  })();

  return (
    <Form.Group className="mb-3 position-relative">
      <div className="d-flex">
        <Form.Control
          type="text"
          placeholder="Type or select instruction"
          value={displayValue}
          onChange={handleChange}
          disabled={disabled}
          onFocus={() => setShowOptions(true)}
          onBlur={() => setTimeout(() => setShowOptions(false), 200)}
          isInvalid={!!errors?.splins}
        />
        {Number(localStorage.getItem("roleId")) < 5 && (
          <Button
            disabled={disabled}
            variant="outline-secondary"
            id="btnsplins"
            onClick={handlePrescriptionModal}
            style={{ marginLeft: '8px' }}
          >
            +
          </Button>
        )}
      </div>

      {showOptions && (
        <div
          className="dropdown-menu show w-100 mt-1"
          style={{
            maxHeight: '150px',
            overflowY: 'auto',
            overflowX: 'hidden',
            whiteSpace: 'normal',
            wordBreak: 'break-word'
          }}
        >
          {splInsOptions.length > 0 ? (
            splInsOptions.map((option, index) => (
              <div
                key={index}
                className="dropdown-item"
                style={{ cursor: 'pointer' }}
                onMouseDown={() => handleSelect(option.value)}
              >
                {option.key}
              </div>
            ))
          ) : (
            <div className="dropdown-item text-muted">No suggestions</div>
          )}
        </div>
      )}

      {errors?.splins && (
        <div className="invalid-feedback d-block mt-1">
          {errors.splins}
        </div>
      )}
    </Form.Group>
  );
};

export default SpecialInstructionInput;
